import { isFfaiPath, toFfaiPublicUrl } from 'shared/lib/ffaiSite';

const AIXC_DEFAULT = 'https://www.aixcrypto.ai';

/**
 * Where a page is seen. ff.com pages show their path; AIXC pages (stored
 * under /cxc10) and ffai.com pages (stored under /ffai) show their full
 * public address, because their stored path isn't what visitors see.
 */
export function pagePublicPath(path: string): string {
  if (!path) return path;
  if (isFfaiPath(path)) return toFfaiPublicUrl(path);
  if (path.startsWith('/cxc10')) {
    const env = typeof window !== 'undefined' ? (window as unknown as { _env_?: { CXC10_DOMAIN?: string } })._env_ : undefined;
    const domain = ((env && env.CXC10_DOMAIN) || AIXC_DEFAULT).replace(/\/$/, '');
    let rest = path.replace(/^\/cxc10/, '') || '/';
    if (!rest.endsWith('/')) rest += '/';
    return `${domain}${rest}`;
  }
  return path;
}
